define.alias("ember-power-select/components/power-select/placeholder", "calendar/components/power-select/placeholder");